
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { ToastModule } from '@openng/optimus-ui/toast';
import { FooterComponent, HeaderComponent } from './@theme/components';
import { User } from './shared/models/user';
import { Config } from './shared/services/config';
import { MasterService } from './shared/services/master.service';

@Component({
    standalone: true,
    selector: 'ngx-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    ToastModule,
    ConfirmDialogModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent
]
})
export class AppComponent implements OnInit {
  @Input() lang = 'en';
  @Input() authToken = '';
  @Input() roles = '';
  @Input() profile = '';

  // menuService = inject(NbMenuService);

  db = Config;
  direction = 'ltr';
  user = Config.user;
  evaIcons = [];

  constructor( //iconsLibrary: NbIconLibraries, 
    private masterService: MasterService, private router: Router,
    // private sidebarService: NbSidebarService,
    // private layoutService: LayoutService,
  ) {
    // iconsLibrary.registerFontPack('fa', { packClass: 'fa', iconClassPrefix: 'fa' });
    // iconsLibrary.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    // iconsLibrary.registerFontPack('fas', { packClass: 'fas', iconClassPrefix: 'fa' });
    // iconsLibrary.registerFontPack('ion', { iconClassPrefix: 'ion' });

    this.setLocalStorageFromQueryString();

    // iconsLibrary.setDefaultPack('fa');
    this.setRoute();

    Config.labels = JSON.parse(localStorage.getItem('labels')) || Config.labels;
    // Config.columns = JSON.parse(localStorage.getItem('columns')) || Config.columns;
    this.masterService.loadTranslationData();
    Config.userChanged.subscribe((user: User) => this.onUserChanged(user));
  }

  setLocalStorageFromQueryString() {
    if (this.lang) {
      localStorage.setItem('lang', this.lang);
      Config.lang = this.lang;
    }
    if (this.authToken) {
      localStorage.setItem('authToken', this.authToken);
    }
    if (this.roles) {
      localStorage.setItem('roles', this.roles);
    }
    if (this.profile) {
      localStorage.setItem('profile', this.profile);
    }
    Config.user = new User();
  }

  setRoute() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        Config.currentRoute.state = this.router.getCurrentNavigation().extras.state || {};
      }
    });
  }

  camelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }

  ngOnInit(): void {
    // this.analytics.trackPageViews();
    if (Config.lang === 'he' || Config.lang === 'ar') {
      this.direction = 'rtl';
    }
  }

  onDocumentClick(event: any) {
    // if (Config.isSmallScreen) {
    //   this.sidebarService.collapse('menu-sidebar');
    // }
  }

  // toggleSidebar(): boolean {
  //   this.sidebarService.toggle(true, 'menu-sidebar');
  //   this.layoutService.changeLayoutSize();

  //   return false;
  // }

  onUserChanged(user: any): void {
    this.user = user;
  }
}
